import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { useLocation } from 'react-router-dom';
import cn from 'classnames';
import { isNil } from 'ramda';

import CashbackPresenter from '../../../presenters/CashbackPresenter';
import BankAccountPresenter from '../../../presenters/BankAccountPresenter';
import TransactionPresenter from '../../../presenters/TransactionPresenter';
import TransactionsList from '../../../pages/Transactions/TransactionsList';
import Group from '../../../components/Group';

import CashbacksList from './components/CashbacksList';
import BankAccountsList from './components/BankAccountsList';

const TRANSACTIONS = 'transactions';
const CASHBACKS = 'cashbacks';
const BANK_ACCOUNTS = 'bankAccounts';

const Lists = (props) => {
  const {
    transactions,
    transactionsCount,
    cashbacks,
    bankAccounts,
    bankAccountsInfo,
    fastCashId,
    onDeleteCashback,
    relay,
    lists,
    searchParams,
    onSearchParamsChange,
    integrationItemsInfo,
    stores
  } = props;

  const isFastCashPage = !isNil(fastCashId);

  const { hash } = useLocation();
  const activeTab = hash.replace('#', '');

  const renderContent = () => {
    switch (activeTab) {
      case TRANSACTIONS:
        return (
          <TransactionsList
            transactions={transactions}
            relay={relay}
            lists={lists}
            bankAccountsInfo={bankAccountsInfo}
            searchParams={searchParams}
            onSearchParamsChange={onSearchParamsChange}
            fastCashId={fastCashId}
            integrationItemsInfo={integrationItemsInfo}
            stores={stores}
          />
        );
      case CASHBACKS:
        return (
          <CashbacksList
            fastCashId={fastCashId}
            cashbacks={cashbacks}
            onDeleteCashback={onDeleteCashback}
            relay={relay}
            searchParams={searchParams}
          />
        );
      case BANK_ACCOUNTS:
        if (!isFastCashPage) return;
        return (
          <BankAccountsList
            fastCashId={fastCashId}
            bankAccounts={bankAccounts}
            relay={relay}
            searchParams={searchParams}
          />
        );
      default:
        return null;
    }
  };

  const count = (key) => {
    switch (key) {
      case TRANSACTIONS:
        // Transactions count passed in meta because of pagination limits in transactions.length
        return transactionsCount;
      case CASHBACKS:
        return cashbacks.length;
      case BANK_ACCOUNTS:
        return bankAccounts.length;
    }
  };
  const navlinkClassName = (tab) =>
    cn('nav-button right-padding', { active: isActive(tab) });

  const isActive = (tab) => tab == activeTab;

  const handleTabChange = (newTab) => (window.location.hash = newTab);

  return (
    <Group>
      <div className="fastcash-tabs">
        <button
          className={navlinkClassName(TRANSACTIONS)}
          onClick={() => handleTabChange(TRANSACTIONS)}
        >{`Transactions (${count(TRANSACTIONS)})`}</button>
        <button
          className={navlinkClassName(CASHBACKS)}
          onClick={() => handleTabChange(CASHBACKS)}
        >{`Cashbacks (${count(CASHBACKS)})`}</button>

        {isFastCashPage && (
          <button
            className={navlinkClassName(BANK_ACCOUNTS)}
            onClick={() => handleTabChange(BANK_ACCOUNTS)}
          >{`Bank Accounts (${count(BANK_ACCOUNTS)})`}</button>
        )}
      </div>

      {renderContent()}
    </Group>
  );
};

Lists.propTypes = {
  cashbacks: PropTypes.arrayOf(CashbackPresenter.shape()).isRequired,
  bankAccounts: PropTypes.arrayOf(BankAccountPresenter.shape()),
  bankAccountsInfo: PropTypes.arrayOf(PropTypes.shape().isRequired),
  fastCashId: PropTypes.string,
  onDeleteCashback: PropTypes.func,
  relay: PropTypes.shape().isRequired,
  lists: PropTypes.shape().isRequired,
  transactions: PropTypes.arrayOf(TransactionPresenter.shape()),
  transactionsCount: PropTypes.number.isRequired,
  searchParams: PropTypes.shape().isRequired,
  onSearchParamsChange: PropTypes.func.isRequired,
};

Lists.defaultProps = {
  fastCashId: null,
  bankAccounts: null,
  bankAccountsInfo: null,
  onDeleteCashback: noop,
  transactions: [],
};

export default Lists;
